import { useEffect } from "react"
import { getParamsFromSelections } from "../utils/queryParams"

/**
 * Hook to keep the URL in sync with the current filter selections.
 * @param {object} selections - The current filter state.
 * @param {number} minCt - The minimum carat bound for the data.
 * @param {number} maxCt - The maximum carat bound for the data.
 * @param {boolean} isInitialized - Whether the initial selections have been set.
 */
export default function useSyncQueryParams(selections, minCt, maxCt, isInitialized) {
    useEffect(() => {
        if (!isInitialized) return

        const currentParams = getParamsFromSelections(selections, minCt, maxCt)
        const currentSearch = currentParams.toString()
        const newUrl = `${window.location.pathname}${currentSearch ? '?' + currentSearch : ''}`
        
        // Only update if the query string has changed to avoid unnecessary history events
        if (window.location.search !== (currentSearch ? '?' + currentSearch : '')) {
            window.history.replaceState({}, '', newUrl)
        }
    }, [selections, minCt, maxCt, isInitialized])
}
